import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import EditorialMarquee from "@/components/EditorialMarquee";
import { BRAND_STORY_IMAGE } from "@/data/products";
import { useMedia } from "@/context/MediaContext";
import Seo from "@/components/Seo";

export default function About() {
  const img = useMedia();
  return (
    <main data-testid="about-page" className="pt-24 md:pt-32">
      <Seo
        title="About Us — Reserve 30 Parfums"
        description="A reserve is what you keep for the moments that matter. Hand-blended, matured 8–10 weeks, bottled at parfum strength in India."
      />
      <div className="max-w-[1440px] mx-auto px-5 md:px-10">
        <Reveal>
          <p className="overline-label">About Us</p>
          <h1 className="font-serif-brand text-5xl sm:text-6xl lg:text-7xl font-light mt-4 leading-[0.95] max-w-3xl">
            A reserve is what you keep for the moments that matter.
          </h1>
        </Reveal>

        <div className="mt-20 grid md:grid-cols-12 gap-12">
          <Reveal className="md:col-span-5">
            <img
              src={img("brand_story", BRAND_STORY_IMAGE)}
              alt="Reserve 30 brand story"
              loading="lazy"
              className="w-full aspect-[3/4] object-cover"
            />
          </Reveal>
          <div className="md:col-span-6 md:col-start-7 space-y-10 self-center">
            <Reveal>
              <h2 className="font-serif-brand text-3xl font-light">Why "30"</h2>
              <p className="mt-4 text-sm md:text-base text-black/60 leading-relaxed">
                Thirty is our threshold — the concentration we refuse to go below, the batch size we refuse to exceed. Reserve 30 was founded on a simple defiance: that Indian perfumery can stand beside the great niche houses of Paris and Grasse, at parfum strength, without compromise.
              </p>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="font-serif-brand text-3xl font-light">The craft</h2>
              <p className="mt-4 text-sm md:text-base text-black/60 leading-relaxed">
                Guided by discipline, minimalism, heritage and honesty — every composition is hand-blended, matured 8–10 weeks, and bottled only when the accord is seamless.
              </p>
            </Reveal>
            <Reveal delay={0.2}>
              <Link to="/collections" data-testid="about-shop-link" className="btn-ink">Explore the Line</Link>
            </Reveal>
          </div>
        </div>
      </div>
      <div className="mt-24">
        <EditorialMarquee />
      </div>
    </main>
  );
}
